export const excelColors = {
  $subTotalGrey: 'e3e3e3',
  $grandTotalGrey: 'cacaca',
};
